module.exports = __webpack_public_path__ + "media/components/utils/ssopSidebarLogo-60180b94ee29f4ed762e4132b847a1f3.svg";